module.exports = __webpack_public_path__ + "static/media/33.aa737165.jpg";